// React import
import React, { Fragment, useEffect, useState, useCallback } from 'react';
//Material component import
import {Divider  } from "@mui/material";
import { CircularProgress } from "@mui/material";
// custom component import
import styles1 from "./DailyProductionInsight.module.css";
import {ComposedChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend } from 'recharts';
import styles from "Samarth Module/components/barAndLineComboChart/barAndLineComboChart.module.css";

const PriorityGraphInsight = ({data, loader})=> {
    const [graphData, setGraphData] = useState([]);
    useEffect(() => {
        setGraphData(data); // for display graph
    }, [data]);
    const CustomLegend = (props) => {
        const { payload } = props;
        return (
            <div style={{ display: 'flex', justifyContent: 'left', padding: '10px' }}>
                {payload.map((entry, index) => {
                    const { value, color } = entry;
                    return (
                        <span
                            key={`item-${index}`}
                            style={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: '4px',
                                padding: '0 10px',
                            }}
                        >
                            <span
                                style={{
                                    backgroundColor: color,
                                    width: '6px',
                                    height: '12px',
                                    display: 'inline-block',
                                    borderRadius: '2px',
                                }}
                            />
                            <span style={{ color: '#4D4D4F' }}>{value}</span>
                        </span>
                    );
                })}
            </div>
        );
    };

    const legendStyle = {
        fontSize: '10px',
        paddingTop: '15px',
        color: '#4D4D4F',
    };

    const CustomTooltip = ({ active, payload }) => {
        if (active && payload && payload.length) {
            return (
                <div className={styles.customTooltip}>
                    <table className={styles1.table}>
                        <tr>
                            <th className={styles1.th}></th>
                            <th className={styles1.th}>Prio 1</th>
                            <th className={styles1.th}>Total</th>
                        </tr>
                        {payload?.map((itm, index)=>
                            <tr key={index}>
                                <th className={styles1.th}>{itm?.name}</th>
                                <td className={styles1.td}>{itm?.value}</td>
                                <td className={styles1.td}>{itm?.payload?.[`${itm?.name} total`]}</td>
                            </tr>
                        )}
                    </table>
                </div>
            );
        }
        return null;
    };
    
	return(
		<Fragment>
            <div className={styles1.graphDiv}>
                <div className={styles1.planText}><span>Priority graph insight</span></div>
                <Divider className={styles1.hr}/>
                {/* Graph */}
                {loader ? 
                    <div className={styles1.loaderContainer}><CircularProgress /></div> :
                    <ComposedChart data={graphData}
                        width={600}
                        height={480}
                        margin={{
                            top: 20,
                            right: 0,
                            bottom: 5,
                            left: 20,
                        }} 
                    >
                        <CartesianGrid strokeDasharray="3 3" vertical={false} horizontal={true} />
                        <XAxis dataKey="Date" tickLine={false} axisLine={false} className={styles.BarLabel} padding={{ left: 0, right: 0 }} >
                            {/* <Label value="Past 4 Weeks" offset={10} position="bottom" style={{ fill: '#2B2B2B', fontSize: '10px', fontWeight: '500' }} /> */}
                        </XAxis>
                        <YAxis domain={[0, 'auto']}  axisLine={false} padding={{ left: 0, right: 0 }}
                            tick={{ 
                                fontSize: 10,           // <-- Decrease this number for smaller font
                                fill: '#2B2B2B', 
                                fontWeight: 400 
                            }}
                            label={{
                                value: 'Quantity (tonnes)',
                                angle: -90,
                                position: 'left',
                                offset: 10,
                                style: {
                                    fill: '#2B2B2B',
                                    fontSize: '10px',
                                    fontWeight: '500',
                                    textAnchor: 'middle',
                                },
                            }}
                        />
                        <Tooltip
                            content={<CustomTooltip />}
                            wrapperStyle={{
                                fontSize: '12px',
                                padding: '6px',
                            }}
                        />
                        <Legend verticalAlign="bottom" align="left" wrapperStyle={legendStyle} content={<CustomLegend />} />
            
                        <Bar
                            radius={[4, 4, 0, 0]}
                            dataKey="System plan"
                            name="System plan"
                            fill="#005EEF"
                            barSize={18}
                        />
                        <Bar
                            dataKey="MM plan"
                            name="MM plan"
                            fill="#00B190"
                            barSize={18}
                            radius={[4, 4, 0, 0]}
                        />
                    </ComposedChart>
                }
            </div>
		</Fragment>
	);
}

export default PriorityGraphInsight;